import { EmptyState } from '@arqam/ui'
import type { LucideIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type PageKey = 'review' | 'spaces' | 'settings'

/** Placeholder page: the page title as h1 and a short description of what will be there. */
export function PageEmpty({ page, icon: Icon }: { page: PageKey; icon: LucideIcon }) {
  const { t } = useTranslation()
  return (
    <EmptyState
      headingLevel={1}
      title={t(`pages.${page}.title`)}
      description={t(`pages.${page}.description`)}
      icon={<Icon size={32} />}
    />
  )
}
